import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
    selector: "app-svg-icon",
    templateUrl: "./svg-icon.component.html",
    styleUrls: ["./svg-icon.component.scss"]
})
export class SvgIconComponent implements OnChanges {
    @Input() public icon = "";
    @Input() public size = 16;
    public linkIcon = "";

    private svgFile = "bootstrap-icons.svg";

    ngOnChanges(changes: SimpleChanges) {
        if (changes.icon != null) {
            this.linkIcon = `/assets/${this.svgFile}#${this.icon}`;
        }
    }

}
